import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkharadi() {



const cardData = {
  keyword: "Cab Service in Kharadi",
  heading: "Lotus Cab: Cab Service in Kharadi",

  headingDescription:
    "Lotus Cab provides professional Cab Service in Kharadi for local travel, airport transfers, and outstation trips. Kharadi is one of Pune’s fastest-growing IT and residential hubs, and timely cab availability is essential for corporate professionals and families. We offer well-maintained AC sedans and spacious SUVs suitable for daily office commutes, airport pickups, and weekend travel. Our drivers are experienced, background-verified, and familiar with Kharadi traffic routes including EON IT Park and nearby business centers. Transparent pricing with no hidden charges ensures complete fare clarity. With 24/7 booking support and quick pickup in Kharadi, we guarantee reliable and comfortable taxi service.",

  top: "Top Places to Visit Near Kharadi with Lotus Cab",

  topPlaces: [
    {
      title: "EON IT Park",
      description:
        "EON IT Park is one of the largest IT hubs in Pune located in Kharadi. It houses major multinational companies and corporate offices. Thousands of professionals commute daily to this business center. Reliable taxi service is essential for timely office travel. Cab service ensures smooth pickup and drop during peak hours. It is a prime corporate location in Kharadi."
    },
    {
      title: "World Trade Center Pune",
      description:
        "World Trade Center in Kharadi is a premium commercial landmark. It hosts corporate offices and international businesses. Professionals frequently require airport and local transfers. Timely cab service supports business travel. Located close to EON IT Park. Reliable taxi service ensures punctual arrival."
    },
    {
      title: "Phoenix Marketcity",
      description:
        "Phoenix Marketcity is one of Pune’s largest shopping malls located near Kharadi. It offers shopping, dining, and entertainment options. Families often visit during weekends. Cab service ensures easy parking-free travel. Comfortable ride enhances shopping experience. Ideal destination for leisure trips."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a historical monument located near Kharadi. It is associated with India’s freedom movement. Tourists visit for heritage and peaceful gardens. It is a short drive from Kharadi. Taxi service ensures comfortable sightseeing. Ideal for history enthusiasts."
    },
    {
      title: "Pune Airport",
      description:
        "Pune International Airport is located close to Kharadi. Business travelers frequently book airport taxis from this area. Timely pickup is critical for flights. 24/7 airport cab service ensures reliable transfer. Comfortable vehicles provide stress-free travel. Ideal for corporate and family airport travel."
    },
    {
      title: "Koregaon Park",
      description:
        "Koregaon Park is a popular residential and nightlife hub near Kharadi. It is known for cafes and restaurants. Visitors frequently require taxi services for evening outings. Safe and reliable cabs ensure comfortable travel. Well-connected route from Kharadi. Ideal for social gatherings."
    },
    {
      title: "Viman Nagar",
      description:
        "Viman Nagar is a nearby residential and commercial area. It houses IT offices and shopping centers. Frequent travel between Kharadi and Viman Nagar occurs daily. Cab service ensures smooth commute. Airport proximity makes it a key area. Comfortable taxi travel is preferred."
    },
    {
      title: "Magarpatta City",
      description:
        "Magarpatta City is another IT and residential hub near Kharadi. Professionals commute between these business centers regularly. Reliable taxi service ensures punctual office travel. Clean and comfortable vehicles enhance daily commute. Ideal for corporate bookings."
    }
  ],

  services: [
    {
      name: "Kharadi Taxi Service",
      description:
        "Reliable taxi service in Kharadi for daily office commute and local travel. AC sedans and SUVs available. Professional drivers ensure safe driving. Transparent fare structure maintained. Quick pickup within Kharadi area. Suitable for corporate and family use."
    },
    {
      name: "Kharadi Airport Cab",
      description:
        "Airport cab service from Kharadi to Pune Airport available 24/7. Timely pickup ensures flight punctuality. Experienced drivers monitor traffic conditions. Comfortable vehicles provided. Transparent pricing maintained. Ideal for domestic and international travel."
    },
    {
      name: "Kharadi Outstation Taxi",
      description:
        "Outstation taxi service from Kharadi for long-distance travel. Safe interstate driving ensured. One-way and round-trip options available. Transparent per km billing followed. Comfortable sedan and SUV options provided. Reliable travel planning guaranteed."
    },
    {
      name: "Corporate Cab Kharadi",
      description:
        "Corporate cab service for professionals in EON IT Park and WTC. Monthly billing options available. Executive sedan options provided. Punctual office commute ensured. Professional drivers assigned. Ideal for business travel."
    },
    {
      name: "SUV Taxi Kharadi",
      description:
        "Spacious SUV taxis suitable for group and family travel. Extra luggage capacity provided. Safe driving ensured. Clean and maintained vehicles available. Ideal for airport and outstation trips. Comfortable travel guaranteed."
    },
    {
      name: "Sedan Cab Kharadi",
      description:
        "Affordable sedan cab for daily travel needs. Ideal for individual and small family use. AC comfort ensured. Transparent pricing policy followed. Quick booking confirmation available. Reliable local transport solution."
    },
    {
      name: "24/7 Taxi Service Kharadi",
      description:
        "Round-the-clock taxi service available in Kharadi. Early morning and late-night rides supported. Immediate booking confirmation provided. Reliable and punctual drivers assigned. Convenient anytime travel ensured."
    },
    {
      name: "Online Cab Booking Kharadi",
      description:
        "Easy online booking available 24/7. Transparent fare estimation provided. Instant driver details shared. Multiple vehicle options offered. Secure and hassle-free booking experience."
    }
  ],

  tableData: [
    ["Cab Service in Kharadi", "Kharadi Taxi Service"],
    ["Kharadi Airport Cab", "Kharadi Outstation Taxi"],
    ["Cab Near EON IT Park Kharadi", "Taxi Near World Trade Center Kharadi"],
    ["Kharadi to Pune Airport Taxi", "Affordable Cab in Kharadi"],
    ["Luxury Taxi Kharadi", "Sedan Cab Kharadi"],
    ["SUV Taxi Kharadi", "Corporate Cab Kharadi"],
    ["24/7 Taxi Service Kharadi", "Online Cab Booking Kharadi"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Fast Pickup in Kharadi",
      WhyChoosedescription:
        "Quick pickup within EON IT Park and nearby areas. Drivers familiar with local routes. Reduced waiting time ensured. Reliable service maintained."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear fare breakdown provided before booking. No hidden charges applied. Honest billing policy maintained."
    },
    {
      WhyChooseheading: "Corporate Travel Expertise",
      WhyChoosedescription:
        "Specialized service for IT professionals. Executive vehicles available. Monthly billing supported."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription:
        "Round-the-clock cab service in Kharadi. Early morning airport rides supported. Late-night travel ensured."
    },
    {
      WhyChooseheading: "Professional Drivers",
      WhyChoosedescription:
        "Background-verified and trained drivers assigned. Safe and smooth driving guaranteed."
    },
    {
      WhyChooseheading: "Well-Maintained Vehicles",
      WhyChoosedescription:
        "Regularly serviced and cleaned fleet. Comfortable AC interiors ensured."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options",
      WhyChoosedescription:
        "Sedan and SUV categories available. Suitable for individual and group travel."
    },
    {
      WhyChooseheading: "Reliable & Trusted Service",
      WhyChoosedescription:
        "On-time pickup and safe drop guaranteed. Stress-free travel experience ensured."
    }
  ]
};

const faqData = [
  { question: "Do you provide airport taxi from Kharadi?", answer: "Yes, 24/7 airport taxi service is available from Kharadi to Pune Airport." },
  { question: "Are corporate bookings available in Kharadi?", answer: "Yes, corporate and monthly billing options are available." },
  { question: "Is SUV available in Kharadi?", answer: "Yes, SUV vehicles are available for family and group travel." },
  { question: "Do you provide outstation taxi from Kharadi?", answer: "Yes, one-way and round-trip outstation taxi service is available." },
  { question: "Is night taxi service available?", answer: "Yes, 24/7 taxi service is available including night rides." },
  { question: "How is fare calculated?", answer: "Fare is calculated based on per km or fixed route pricing with transparent billing." },
  { question: "Can I book online?", answer: "Yes, online booking is available 24/7 with instant confirmation." },
  { question: "Are toll charges included?", answer: "Toll charges are shared clearly before booking confirmation." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended during peak hours." },
  { question: "Do drivers know IT park routes?", answer: "Yes, drivers are familiar with EON IT Park and WTC routes." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Kulkarni",
    feedback:
      "Using Lotus Cab for daily office commute in Kharadi has been reliable. Drivers are punctual and professional. Transparent pricing and clean vehicles. Highly recommended for corporate travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Sharma",
    feedback:
      "Booked airport taxi from Kharadi. Cab arrived on time and journey was smooth. No hidden charges in billing. Comfortable travel experience.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Nitin Patil",
    feedback:
      "SUV booking for family outing was excellent. Spacious vehicle and safe driving. Reliable cab service in Kharadi.",
    rating: 5
  }
];























































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kharadi",
  "image": "https://lotuscab.com/assets/images/cab-service-kharadi.jpg", 
  "description": "Lotus Cab provides reliable cab service in Kharadi, including airport transfers, outstation trips, corporate travel, and local rides near EON IT Park and World Trade Center. Book affordable sedan, SUV, and luxury taxis with 24/7 online booking and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6000"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/cab-service-kharadi"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Cab Service in Kharadi | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book cab service in Kharadi with Lotus Cab. Affordable local, airport, outstation & corporate taxis near EON IT Park & World Trade Center. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Cab Service in Kharadi, Kharadi Taxi Service, Kharadi Airport Cab, Kharadi Outstation Taxi, Cab Near EON IT Park Kharadi, Taxi Near World Trade Center Kharadi, Kharadi to Pune Airport Taxi, Affordable Cab in Kharadi, Luxury Taxi Kharadi, Sedan Cab Kharadi, SUV Taxi Kharadi, Corporate Cab Kharadi, 24/7 Taxi Service Kharadi, Online Cab Booking Kharadi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinkharadi;